module.exports = __webpack_public_path__ + "media/images/social/max-av-ae56fa0eab0664d112e5e66e8afa833d.svg";